import { RelatedToType } from 'app/shared/enums';
import { TileServerItem } from './research.service';

export interface PropertyUseCode {
  id: number;
  name: string;
}

export interface LatLng {
  latitude: number;
  longitude: number;
}

export interface Layer {
  id: string;
  name: string;
  label: string;
  attribute?: string;
  url?: string;
  type: string;
  active?: boolean;
  category?: string;
  minZoom?: number;
  layerType?: TileServerItem['layerType'];
}

export interface LayerCategory {
  category: string;
  layers: Layer[];
}

export interface ReverseGeoCode {
  address: string;
  city?: string;
  country: string;
  lat: string;
  lng: string;
  postal_code: string;
  state: string;
  state_code: string;
  street: string;
}

export interface BoundingBox {
  sw: [number, number];
  ne: [number, number];
}

export interface FilterForm {
  owner: string;
  owner_mailing_address: string;
  zoning: string;
  min_building_area_sq_ft: number | null;
  max_building_area_sq_ft: number | null;
  min_lot_area_acres: number | null;
  max_lot_area_acres: number | null;
  min_lot_area_sq_ft: number | null;
  max_lot_area_sq_ft: number | null;
  min_units: number | null;
  max_units: number | null;
  min_estimated_value: number | null;
  max_estimated_value: number | null;
}

export type Parcel = {
  avm: any;
  foreclosures: any[];
  parcel: {
    addrLine1: string;
    apn: string;
    apn2: null | string;
    city: string;
    countyName: string;
    fipsCounty: null | string;
    fipsState: string;
    id: string;
    latitude: number;
    longitude: number;
    ogcFid: number;
    srcId: string;
    state: string;
    zip: string;
  };
  recorders: any[];
  rentalAvm: any;
  taxAssessor: any;
};

export enum ResearchLayoutKeys {
  SEARCH_OWNER = 'research-search-owner',
  SEARCH_MAILING_ADDRESS = 'research-search-address',
  VIEW_AS_TABLE = 'research-view-as-table',
}

export type MarkerType = RelatedToType.Project | RelatedToType.Property;
